
import XButton from 'vux/src/components/x-button/index.vue'


export default {
components: {
XButton,
},
name: 'person-info',
data() {
return {
showDialog: false,
registrantInfo: {
userName: this.$route.query.userName,
ide: this.$route.query.ide,
movePhone: this.$route.query.movePhone,
cardPhotoFace: this.$route.query.cardPhotoFace
}
}
},

created() {
const openid = window.sessionStorage.getItem("openId")

if (String(this.$route.query.orderStatus) === 'PASS') {
this.syncEspUser(openid);
return;
}
if (this.registrantInfo.userName == undefined && this.registrantInfo.ide == undefined && this.registrantInfo.movePhone == undefined) {
this.isRegister(openid);
}
},

computed: {


isExpiringSoon() {
const expire = this.registrantInfo.certExpireTime;
if (!expire) {
return false;
}

const match = String(expire).trim().match(/^(\d{4})-(\d{1,2})-(\d{1,2})/);
if (!match) {
return false;
}
const expireYear = Number(match[1]);
const expireMonth = Number(match[2]) - 1; 
const expireDay = Number(match[3]);
const now = new Date();

const expireMs = Date.UTC(expireYear, expireMonth, expireDay);
const todayMs = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate());
const diffDays = Math.round((expireMs - todayMs) / (24 * 60 * 60 * 1000));
return diffDays >= 0 && diffDays <= 30;
}
},

methods: {
getImages(id) {
return require(`@/assets/images/${id}.png`)
},


syncEspUser(openid) {
if (!openid) {
this.isRegister(openid);
return;
}
const url = '/wechat/syncEspUser.do?type=1&openid=' + openid;
this.$axios({
method: 'get',
url: url
}).then((response) => {
this.$router.push({path: '/personInfo'});
this.isRegister(openid);
}).catch(() => {
this.$router.push({path: '/personInfo'});
this.isRegister(openid);
})
},

isRegister(openid, skipReAuth) {
const url = '/wechat/queryUser.do?openId=' + openid;
this.$axios({
method: 'get',
url: url
}).then((response) => {
if (response.data.code === 200) {
this.registrantInfo = response.data.result;

if (String(this.registrantInfo.espstatus) === '0' || !this.registrantInfo.espstatus) {
this.$router.push({path: '/register'});
} else if (String(this.registrantInfo.espstatus) === '3') {

if (!skipReAuth) {
this.reAuth();
}
}
} else {
this.$vux.toast.hide();
this.$router.push({path: '/register'});
}
})
},

jumpPage() {
this.$router.push({path: '/productsCenter'});
},

reAuth() {
const openid = window.sessionStorage.getItem("openId")
const taskUrl = '/wechat/myTaskWait.do';
this.$axios({
method: 'get',
url: taskUrl,
params: {
openId: openid,
applyUser: '',
taskType: '',
pageIndex: 1,
pageSize: 999
}
}).then((response) => {
if (response.data.code === 200) {
const tasks = (response.data.result && response.data.result.tasks) || [];
if (tasks.length > 0) {

this.$vux.confirm.show({
title: '提示',
content: '您还有未处理的待办任务，暂无法进行实名认证。请先联系业务人员作废相关待办任务后再试。',
showCancelButton: false,
confirmText: '我知道了'
});
return;
}
}

this.showReAuthConfirm(openid);
}).catch(() => {
this.showReAuthConfirm(openid);
})
},

showReAuthConfirm(openid) {
this.$vux.confirm.show({
title: '提示',
content: '确定重新进行实名认证吗？如果已通过实名认证，会刷新当前实名结果',
onConfirm: () => {
const url = '/wechat/syncEspUser.do?type=1&openid=' + openid;
this.$axios({
method: 'get',
url: url
}).then((response) => {
const data = response.data || {};
if (data.code === 200) {
const result = data.result;
if (result.code === '0') {

this.$router.push({path: '/register'});
} else if (result.code === '1' && result.status) {

if((result.status === '1'||result.status === '2' ||result.status === '3') && result.certificationUrl!=null){
window.location.href = result.certificationUrl;
} else if (result.status === '2') {
setTimeout(() => {

this.$router.push({path: '/personInfo'}).catch(err => {
err
});

this.isRegister(openid, true);
}, 500);
}
} else {
this.$router.push({path: '/register'});
}
} else {
alert("请联系管理员")
}
})
}
});
}
}
}



// WEBPACK FOOTER //
// ./src/pages/PersonInfo.vue